export const workerCode = () => {
  let timer: string | number | NodeJS.Timeout | undefined;
  onmessage = (e) => {
    const { secondsLeft } = e.data;
    timer = setInterval(() => {
      if (secondsLeft > 0) {
        postMessage({ secondsLeft: secondsLeft - 1 });
      } else {
        clearInterval(timer);
      }
    }, 1000);
  };
};
